import script from "./LicensesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LicensesTable.vue?vue&type=script&setup=true&lang=js"

import "./LicensesTable.vue?vue&type=style&index=0&id=2032361c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2032361c"]])

export default __exports__